import axios from '../utils/axios';

export default function fetchApplications(adminId, jobId, params) {
    return (
        axios.get('/admin/' + adminId + '/job/' + jobId + '/applications', { params })
    )
}
